export type LocaleListItem = {
  name: string;
  locale: string;
  flagName: string;
  // https://en.wikipedia.org/wiki/IETF_language_tag
  bcp47Locale: string;
  // https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
  iso6391: string;
  // https://git.flix.tech/webc/cms/go/modules/langfigurator/-/blob/master/language/language.go?ref_type=heads#L22
  drupal: string;
};
export type LocaleListInternal = Array<LocaleListItem>;
export type LocaleListExternal = Array<Required<LocaleListItem>>;
